import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

/**
 * Replacement for react-router-dom v5's withRouter HOC.
 * Injects navigate, location, and params as props into the wrapped component.
 *
 * Usage:
 *   compose(withRouterHooks)(MyComponent)
 *
 * Then access via this.props.navigate, this.props.location, this.props.params
 */
export const withRouterHooks = (Component) => {
  function WrappedComponent(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    return <Component {...props} navigate={navigate} location={location} params={params} />;
  }
  WrappedComponent.displayName = `withRouterHooks(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};

export default withRouterHooks;
